export const FORGOT_PASSWORD_CREATE = 'FORGOT_PASSWORD_CREATE';
export const FORGOT_PASSWORD_CREATE_INIT = 'FORGOT_PASSWORD_CREATE_INIT';
export const FORGOT_PASSWORD_CREATE_DONE = 'FORGOT_PASSWORD_CREATE_DONE';

export const FORGOT_PASSWORD_UPDATE = 'FORGOT_PASSWORD_UPDATE';
export const FORGOT_PASSWORD_UPDATE_INIT = 'FORGOT_PASSWORD_UPDATE_INIT';
export const FORGOT_PASSWORD_UPDATE_DONE = 'FORGOT_PASSWORD_UPDATE_DONE';
